import { mapGetters } from 'vuex';

export default {
    computed: {
        ...mapGetters({
            tikklok: 'currentUser/getTikklok',
            userLocation: 'currentUser/getUserLocation',
            loggedIn: 'currentUser/isValidLogin',
        }),
        routerViewStyle() {
            let margin = 0;
            if (this.loggedIn) {
                if (this.tikklok.showActions && this.userLocation) {
                    margin = 137;
                } else {
                    margin = 95;
                }
            }
            return { 'margin-top': margin + 'px' };
        },
    },
};
